import React, { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Sparkles, Send, Loader2, Bot } from "lucide-react";

const SUGGESTIONS = [
  "Berapa WhatsApp masuk hari ini?",
  "Berapa hot leads sekarang?",
  "Staff siapa paling banyak sales?",
  "Broadcast mana paling banyak revenue?",
  "Berapa revenue dari WhatsApp?",
];

export default function Assistant() {
  const [messages, setMessages] = useState([
    { role: "ai", text: "Salam! Saya AI Management Assistant. Tanya saya apa-apa tentang prestasi WhatsApp bisnes anda — leads, sales, staff, revenue atau kempen. 📊" },
  ]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => { if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight; }, [messages, busy]);

  const ask = async (q) => {
    const question = q || input;
    if (!question.trim() || busy) return;
    setMessages((m) => [...m, { role: "user", text: question }]);
    setInput(""); setBusy(true);
    try {
      const r = await api.post("/ai/assistant", { question });
      setMessages((m) => [...m, { role: "ai", text: r.data.answer }]);
    } catch {
      toast.error("AI tidak tersedia");
      setMessages((m) => [...m, { role: "ai", text: "Maaf, saya tidak dapat memproses sekarang. Cuba lagi." }]);
    } finally { setBusy(false); }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)] max-w-3xl mx-auto w-full" data-testid="assistant-page">
      <div className="p-6 border-b border-border">
        <h1 className="font-display text-2xl font-bold tracking-tight flex items-center gap-2"><Sparkles className="h-6 w-6 text-violet-600" /> AI Management Assistant</h1>
        <p className="text-muted-foreground text-sm mt-1">Tanya soalan bisnes dalam Bahasa Malaysia — jawapan berdasarkan data sebenar.</p>
      </div>

      <div ref={scrollRef} className="flex-1 overflow-y-auto p-6 space-y-4">
        {messages.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
            {m.role === "ai" && <div className="h-8 w-8 rounded-full bg-violet-100 text-violet-600 flex items-center justify-center mr-2 shrink-0"><Bot className="h-4 w-4" /></div>}
            <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm whitespace-pre-wrap ${
              m.role === "user" ? "bg-primary text-primary-foreground rounded-tr-sm" : "bg-secondary text-foreground rounded-tl-sm"}`}>
              {m.text}
            </div>
          </div>
        ))}
        {busy && (
          <div className="flex justify-start">
            <div className="h-8 w-8 rounded-full bg-violet-100 text-violet-600 flex items-center justify-center mr-2"><Bot className="h-4 w-4" /></div>
            <div className="bg-secondary rounded-2xl px-4 py-3 rounded-tl-sm"><Loader2 className="h-4 w-4 animate-spin" /></div>
          </div>
        )}
      </div>

      <div className="p-4 border-t border-border">
        <div className="flex gap-2 mb-3 overflow-x-auto pb-1">
          {SUGGESTIONS.map((s) => (
            <button key={s} onClick={() => ask(s)} data-testid={`assistant-suggestion-${s.slice(0, 10)}`}
              className="shrink-0 text-xs px-3 py-1.5 rounded-full bg-secondary hover:bg-accent text-muted-foreground hover:text-accent-foreground transition-colors">
              {s}
            </button>
          ))}
        </div>
        <div className="flex items-end gap-2">
          <textarea data-testid="assistant-input" value={input} onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); ask(); } }}
            rows={1} placeholder="Tanya soalan bisnes anda..."
            className="flex-1 resize-none rounded-2xl bg-secondary px-4 py-3 text-sm outline-none max-h-32" />
          <Button size="icon" onClick={() => ask()} disabled={busy} data-testid="assistant-send-button" className="rounded-full h-11 w-11 shrink-0">
            <Send className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
